type Props = {
  data: unknown;
};

export function JsonLd({ data }: Props) {
  if (data == null) {
    return null;
  }
  return (
    <script
      type="application/ld+json"
      // biome-ignore lint/security/noDangerouslySetInnerHtml: <this is actually how Next.js recommends to do it https://nextjs.org/docs/app/guides/json-ld>
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(data).replace(/</g, "\\u003c"),
      }}
    />
  );
}
